/*******************************************************************************
TRIGGERS SHOWING SUB PAGES
Triggers showing the sub pages for the tab that was clicked on.
*******************************************************************************/

import toggleSubPages from './toggle-sub-pages';

export default function triggerShowSubPages(e) {
    const tabName = $(e.currentTarget).data('name') || '';
    if (!tabName) { return; }
    toggleSubPages(tabName);
}
